import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditableTableComponent } from './editable-table.component';
import { EditableTableService } from './editable-table.service';


export class EditableTableModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule
  ],
  declarations: [
    EditableTableComponent,
  ],
  providers: [EditableTableService],
  exports: [EditableTableComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
